// extracted by mini-css-extract-plugin
export default {"DetailPanel__sender":"DetailPanelNoticeHeader_DetailPanel__sender__lbAam"};